import { useState, useMemo, useCallback } from 'react';
import { rowMatchesSearch, generateSearchSuggestions } from '../utils/searchUtils';

/**
 * Hook for managing data filtering and search functionality
 */
export function useDataFiltering(filteredData = []) {
  const [quickFilterText, setQuickFilterText] = useState('');
  
  // Filter data based on search text
  const displayData = useMemo(() => {
    let data = filteredData;
    
    // Apply search filter if text exists
    if (quickFilterText && quickFilterText.trim() !== '') {
      const searchWords = quickFilterText.toLowerCase().trim().split(/\s+/).filter(word => word.length > 0);
      
      // Use centralized search logic
      data = data.filter(row => rowMatchesSearch(row, searchWords));
    }
    
    return data;
  }, [filteredData, quickFilterText]);
  
  // Generate search suggestions using centralized logic
  const searchSuggestions = useMemo(() => {
    return generateSearchSuggestions(filteredData);
  }, [filteredData]);
  
  // Clear search filter
  const clearSearch = useCallback(() => {
    setQuickFilterText('');
  }, []);
  
  // Check if search is active
  const isSearchActive = useMemo(() => {
    return quickFilterText && quickFilterText.trim() !== '';
  }, [quickFilterText]);
  
  // Get search result count
  const searchResultCount = useMemo(() => {
    if (!isSearchActive) return filteredData.length;
    return displayData.length;
  }, [isSearchActive, filteredData.length, displayData.length]);
  
  return {
    // State
    quickFilterText,
    setQuickFilterText,
    
    // Filtered data
    displayData,
    
    // Search suggestions
    searchSuggestions,
    
    // Methods
    clearSearch,
    
    // Computed values
    isSearchActive,
    searchResultCount
  };
}